import { Button, Dialog, DialogContent, DialogTitle, Grid, MenuItem, Select, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import { useState } from "react";
import { AppraisalReviewStore } from "../stores";
import { MANUAL_EDIT_APPRAISAL_REVIEW, PLEASE_SELECT_AN_OPTION_TO_CONTINUE, SCOPE_OF_WORK_INVALID } from "./constants";
import { useRocInternalPortalStore } from "apps/roc-internal-portal/src/app/hooks";
import { ScopeOfWorkV2FormParams } from "@roc/feature-sow-shared/types";
import { isNil } from "@roc/feature-utils";
import { Document } from "@roc/feature-types";
import { WithDocumentActions } from "@roc/feature-documents";

interface Props {
  loanId: number;
  propertyId: number;
  store: AppraisalReviewStore;
  document: Document;
}

export const InternalRevisionTextBoxButton = observer((props: Props) => {

  const { scopeOfWorkInternalStore } = useRocInternalPortalStore();

  const { loanId, propertyId, store, document } = props;
  const [openTextBox, setOpenTextBox] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const handleConfirmationRequestRevisionAction = (valueSelected) => {
    if (valueSelected !== 'Select') {
      if (valueSelected === 'CMT') {
        validateScopeOfWork(loanId, propertyId)
          .then(isValidSow => {
            if (isValidSow) {
              store.requestRevision(propertyId, loanId, valueSelected);
            }
            else {
              store.showWarningNotification(SCOPE_OF_WORK_INVALID);
            }
          })
      } else if (valueSelected === 'UNDERWRITER') {
        underwritterValueSelected(isUnderwrittertPresent, store, propertyId, loanId, valueSelected);
      } else {
        store.requestRevision(propertyId, loanId, valueSelected);
      }
    } else {
      setShowErrorMessage(true);
    }
  };

  const isUnderwrittertPresent = () => {
    return !isNil(store.loanActors?.underwriterId);
  }

  const underwritterValueSelected = (isUnderwrittertPresent: () => boolean, store: AppraisalReviewStore, propertyId: number, loanId: number, valueSelected: any) => {
    if (isUnderwrittertPresent()) {
      store.requestRevision(propertyId, loanId, valueSelected);
    }
    else {
      store.globalStore.notificationStore.showErrorNotification({
        message: 'There is no Underwritter selected for this loan',
      });
    }
  }

  const validateScopeOfWork = async (loanId, propertyId) => {
    const params: ScopeOfWorkV2FormParams = {
      loanId: loanId.toString(),
      propertyId: propertyId.toString()
    }
    const response = await scopeOfWorkInternalStore.getScopeOfWorkWithParameters(params);
    if (!isNil(response) && !isNil(response['status']) && response['status'] != 'Draft') {
      return true;
    }
    return false;
  }

  const handleOpenModal = () => {
    const count = store.revisions.filter(rev => rev.sendForRevision).length;
    if (count > 0) {
      setOpenTextBox(true);
    } else {
      store.showWarningNotification(PLEASE_SELECT_AN_OPTION_TO_CONTINUE);
    }
  }

  const TextBoxDialog = () => {
    const [valueSelected, setValueSelected] = useState("Select")
    const handleChange = (event) => {
      setValueSelected(event.target.value)
    }

    const handleClose = (_, reason) => {
      if (reason === 'backdropClick') {
        return;
      }
      setOpenTextBox(false);
    }

    return (
      <Dialog
        open={openTextBox}
        onClose={handleClose}
        fullWidth
      >
        <DialogTitle>
          {"Who would you like to send this file to?"}
        </DialogTitle>
        <DialogContent style={{ overflow: 'hidden' }}>
          <Grid container xs={12} direction="column" spacing={2}>
            <Select
              value={valueSelected}
              onChange={handleChange}
              variant="outlined"
              fullWidth
            >
              <MenuItem value={"Select"}>Select</MenuItem>
              <MenuItem value={"AMC"}>AMC</MenuItem>
              <MenuItem value={"TPO"}>Lender</MenuItem>
              <MenuItem value={"UNDERWRITER"}>Underwriter</MenuItem>
            </Select>
            {showErrorMessage && (<Typography variant="caption" style={{ color: 'red' }}> ** Please select one of the options to continue.</Typography>)}
            <Grid container spacing={2} xs={12} justifyContent="flex-end" style={{ marginTop: 20 }} direction="row">
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setOpenTextBox(false)}
                style={{ marginBottom: 20, marginRight: 5 }}
              >
                CANCEL
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{ marginBottom: 20 }}
                onClick={() => handleConfirmationRequestRevisionAction(valueSelected)}
              >
                SUBMIT
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    )
  }

  return (
    <Grid item xs={12} >
      <TextBoxDialog />
      <WithDocumentActions
        component={Button}
        document={document}
        variant="contained"
        color="primary"
        fullWidth
        onClick={handleOpenModal}
        disabled={store.manualAutomatedStatus === MANUAL_EDIT_APPRAISAL_REVIEW}
      >
        REQUEST REVISION
      </WithDocumentActions>
    </Grid>
  )
})
